module.exports = __webpack_public_path__ + "img/brand-block-5.1d9628cb.png";